import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  background-color: var(--color-white);
  padding: 24px;
  border-radius: 10px;
  box-shadow: 4px 4px 29px rgba(19, 69, 186, 0.0855129);
  margin-top: 32px;
  margin-bottom: 16px;
  position: relative;
`

const Form = styled.div`
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 16px;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
`
const Footer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  width: 100%;
  gap: 16px;
  position: relative;
  justify-content: flex-end;
`

const Textarea = styled.textarea<{ isError: boolean }>`
  position: relative;
  width: 100%;
  height: 176px;
  font-size: 14px;
  word-break: break-word;
  outline: none;
  border: none;
  //resize: none;
  border-color: ${({ isError }) => isError && 'var(--color-text-error)'};
`

const Error = styled.div`
  font-size: 12px;
  position: absolute;
  left: 0;
  top: 100%;
  margin-top: -12px;
  color: var(--color-text-error);
`

const InputContainer = styled.div<{ isError: boolean }>`
  width: 100%;
  position: relative;
  border: 1px solid lightgrey;
  border-radius: 10px;
  border-color: ${({ isError }) => (isError ? 'var(--color-text-error)' : 'lightgrey')};

  * {
    padding: 1rem;
    border-radius: inherit;
  }
`

export { Container, Form, Footer, Textarea, Error, InputContainer }
